export default "__VITE_PUBLIC_ASSET__6def9bfd__"